<template>
  <div>
    <LlQuestionList
      v-for="(chapter, chapterIndex) in chapterList"
      :key="chapterIndex"
      has-annex
      ques-result
      text-label="查核提示"
      content-icon="icon-light"
      :title="chapter.title"
      :question-list="chapter.sectionList"
      :law-content="lawContent"
      @law-click="$emit('createSubmit', $event)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      chapterList: [
        {
          title: "危害性化學品",
          sectionList: [
            {
              sectionTitle: "標示及通識危害資訊",
              questionList: [
                {
                  result: 25,
                  focus: 1,
                  title:
                    "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
                  subtitle: "建議題目",
                  remark:
                    "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
                  attaches: ["attache", "eeewref.pdf"],
                  images: ["image"],
                  articles: [
                    {
                      last_version: {
                        no_text: "no2",
                      },
                      act_version: {
                        id: 100,
                        name: "ddd",
                      },
                    },
                  ],
                  riskSignal: [
                    { name: "罰鍰", icon: "" },
                    { name: "罰鍰", icon: "" },
                  ],
                  alertText: "風險：停廠停業、罰鍰",
                },
                {
                  result: 20,
                  focus: 1,
                  title:
                    "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
                  subtitle: "自訂題目",
                  remark:
                    "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
                  attaches: ["attache"],
                  images: ["image"],
                  riskSignal: [
                    { name: "罰鍰", icon: "" },
                    { name: "罰鍰", icon: "" },
                  ],
                  alertText: "風險：停廠停業、罰鍰",
                },
              ],
            },
            {
              sectionTitle: "危害性化學品之教育訓練",
              questionList: [
                {
                  result: 21,
                  focus: 0,
                  title:
                    "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
                  subtitle: "建議題目",
                  remark:
                    "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
                  attaches: ["attache"],
                  images: ["image"],
                  articles: [
                    {
                      last_version: {
                        no_text: "no2",
                      },
                      act_version: {
                        id: 100,
                        name: "ddd",
                      },
                    },
                  ],
                  riskSignal: [
                    { name: "罰鍰", icon: "" },
                    { name: "罰鍰", icon: "" },
                  ],
                  alertText: "風險：停廠停業、罰鍰",
                },
              ],
            },
          ],
        },
        {
          title: this.$t("其他"),
          sectionList: [
            {
              sectionTitle: "",
              questionList: [
                {
                  result: 23,
                  focus: 1,
                  title:
                    "對於具有危害性之化學品，予以標示、製備清單及揭示安全資料表，並採取必要之通識措施。",
                  subtitle: "建議題目",
                  remark:
                    "標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準內容文字標準",
                  attaches: ["attache"],
                  images: ["image"],
                  articles: [
                    {
                      last_version: {
                        no_text: "no2",
                      },
                      act_version: {
                        id: 100,
                        name: "ddd",
                      },
                    },
                  ],
                  riskSignal: [
                    { name: "罰鍰", icon: "" },
                    { name: "罰鍰", icon: "" },
                  ],
                  alertText: "風險：停廠停業、罰鍰",
                },
              ],
            },
          ],
        },
      ],
      lawContent: {
        title: "水污法水污法水污法水污法 第21條",
        content:
          "本辦法用詞，定義如下：一、環境保護專責及技術人員：指前條法律規定之專責人員、專業技術人員，其類別與級別如下：（一）空氣污染防制專責人員，其級別分為甲級及乙級。（二）廢（污）水處理專責人員，其級別分為甲級及乙級。（三）毒性化學物質專業技術管理人員，其級別分為甲級、乙級及丙級。（四）廢棄物清理專業技術人員：    1.廢棄物清除專業技術人員，其級別分為甲級、乙級及丙級。    2.廢棄物處理專業技術人員，其級別分為甲級及乙級。（五）環境用藥專業技術人員：    1.環境用藥製造業專業技術人員。    2.環境用藥販賣業專業技術人員。    3.病媒防治業專業技術人員。（六）室內空氣品質維護管理專責人員。（七）土壤污染評估調查人員。（八）健康風險評估專責人員。二、訓練：指環境保護專責及技術人員之證照訓練、到職訓練及在職訓。",
        commentTitle: "理律評析",
        riskSignal: [
          { icon: "icon-water", text: "停廠停業" },
          { icon: "icon-water", text: "停廠停業" },
        ],
        commentContent:
          "請確認是否指定為內文內文內文內文內文內文，內文內文內文內文內文內文，內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文，內文內文內文內文內文內文內文內文內文內文、內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內文內內文內文內文內文內文內。",
      },
    }
  }
}
</script>

<style>

</style>